import { render, staticRenderFns } from "./ImgHeader.vue?vue&type=template&id=69080ed4&"
import script from "./ImgHeader.vue?vue&type=script&lang=js&"
export * from "./ImgHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports